import { render, staticRenderFns } from "./wePay.vue?vue&type=template&id=fd6c1638&scoped=true"
import script from "./wePay.vue?vue&type=script&lang=js"
export * from "./wePay.vue?vue&type=script&lang=js"
import style0 from "./wePay.vue?vue&type=style&index=0&id=fd6c1638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6c1638",
  null
  
)

export default component.exports